// extracted by mini-css-extract-plugin
module.exports = {"containerImagem":"Foto_containerImagem__UwnVB","carregandoImagem":"Foto_carregandoImagem__JBdWj","barra":"Foto_barra__3XfDn"};